import { useDataValue, useDataChange, DataProvider } from 'Simple/Data.js'
import ActionsAction from './ActionsAction/index.js'
import AssignedTo from './AssignedTo/index.js'
import CommentsLogs from './CommentsLogs/index.js'
import Priority from './Priority/index.js'
import DueDate from './DueDate/index.js'
import TaskOverview from './TaskOverview/index.js'
import SelectAction from './SelectAction/index.js'
import SelectAllAction from './SelectAllAction/index.js'
import React, { useMemo } from 'react'

import View from './view.js'

export default function Logic(props) {
  let tasks = useDataValue({
    context: 'tasks',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let value = useMemo(() => {
    let columns = [
      {
        id: 'select-col',
        header: ({ table }) => (
          <SelectAllAction
            value={table.getIsAllRowsSelected()}
            onChange={() =>
              table.toggleAllRowsSelected(!table.getIsAllRowsSelected())
            }
          />
        ),
        width: '14px',
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'select',
        cell: ({ cell, row }) => {
          return (
            <SelectAction
              viewPath={`${props.viewPath}/SelectAction(${cell.row.original.id})`}
              value={row.getIsSelected()}
              onChange={row.getToggleSelectedHandler()}
            />
          )
        },
      },
      {
        id: 'task',
        header: () => <div style={{ textAlign: 'left' }}>Patient / Task</div>,
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'employee_name',
        cell: ({ cell, row }) => {
          return (
            <DataProvider
              context="task"
              value={cell.row.original}
              viewPath={props.viewPath}
            >
              <TaskOverview
                viewPath={`${props.viewPath}/TaskOverview(${cell.row.original.id})`}
              />
            </DataProvider>
          )
        },
      },
      {
        id: 'assignee',
        header: () => <div style={{ textAlign: 'left' }}>Assigned to</div>,
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'user_id',
        cell: ({ cell, row }) => {
          return (
            <DataProvider
              context="task"
              value={cell.row.original}
              viewPath={props.viewPath}
            >
              <AssignedTo
                viewPath={`${props.viewPath}/AssignedTo(${cell.row.original.id})`}
              />
            </DataProvider>
          )
        },
      },
      {
        id: 'due',
        width: '100px',
        header: () => 'Due date',
        enableSorting: true,
        enableColumnFilter: false,
        accessorKey: 'due_date',
        cell: ({ cell, row }) => {
          return (
            <DataProvider
              context="task"
              value={cell.row.original}
              viewPath={props.viewPath}
            >
              <DueDate
                viewPath={`${props.viewPath}/DueDate(${cell.row.original.id})`}
              />
            </DataProvider>
          )
        },
      },
      {
        id: 'priority',
        header: () => <div style={{ textAlign: 'left' }}>Priority</div>,
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'priority',
        cell: ({ cell, row }) => {
          return (
            <DataProvider
              context="task"
              value={cell.row.original}
              viewPath={props.viewPath}
            >
              <Priority
                viewPath={`${props.viewPath}/Priority(${cell.row.original.id})`}
              />
            </DataProvider>
          )
        },
      },
      {
        id: 'comments',
        header: () => <div style={{ textAlign: 'center' }}>Comments & Log</div>,
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'comments_count',
        cell: ({ cell, row }) => {
          return (
            <DataProvider
              context="task"
              value={cell.row.original}
              viewPath={props.viewPath}
            >
              <CommentsLogs
                viewPath={`${props.viewPath}/CommentsLogs(${cell.row.original.id})`}
              />
            </DataProvider>
          )
        },
      },
      {
        id: 'actions',
        header: () => <div style={{ textAlign: 'center' }}>Actions</div>,
        enableSorting: false,
        enableColumnFilter: false,
        accessorKey: 'stages',
        cell: ({ cell, row }) => {
          return (
            <DataProvider
              context="task"
              value={cell.row.original}
              viewPath={props.viewPath}
            >
              <ActionsAction
                viewPath={`${props.viewPath}/ActionsAction(${cell.row.original.id})`}
              />
            </DataProvider>
          )
        },
      },
    ].filter(Boolean)

    if (!tasks) return { columns, data: [] }

    return {
      columns,
      data: tasks,
    }
  }, [tasks]) //eslint-disable-line

  function onChange(table) {
    let rows = table.getSelectedRowModel().rows

    change(next => {
      next.bulk_task_ids = rows.map(row => row.original.id)
      next.bulk_tasks = rows.map(row => row.original)
    })
  }

  return <View value={value} onChange={onChange} viewPath={props.viewPath} />
}
